import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SharedService } from 'src/app/_shared/shared.service';

@Component({
  selector: 'app-admin-users',
  templateUrl: './admin-users.component.html',
  styleUrls: ['./admin-users.component.scss']
})
export class AdminUsersComponent implements OnInit {

  activeTab = 1;

  tabUsers = {
    refreshUrl: 'admin/users/list',
    detailUrl: 'admin/users',
    detailId: 'id_user',
    cols: [
      { type: 'text', attr: 'fullname', header: 'Jméno' },
      { type: 'text', attr: 'username', header: 'Uživatel' },
      { type: 'text', attr: 'email', header: 'Email' },
      { type: 'text', attr: 'client_name', header: 'Klient' },
      { type: 'bool', attr: 'active', header: 'Aktivní' },
      { type: 'datetime', attr: 'email_verified_at', header: 'Ověřen' }
    ]
  };

  tabClients = {
    refreshUrl: 'clients/list',
    detailUrl: 'admin/clients',
    detailId: 'id_client',
    cols: [
      { type: 'text', attr: 'name', header: 'Název' },
      { type: 'text', attr: 'city', header: 'Město' },
      { type: 'text', attr: 'street', header: 'Ulice' },
      { type: 'text', attr: 'manager_name', header: 'Kontakt' }
    ]
  };

  constructor(
    public shared: SharedService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.activeTab = this.shared.loadActiveTab('rep_admin_users_tab', false, 1);
  }

  onTabChange(): void {
    this.shared.saveActiveTab('rep_admin_users_tab', false, this.activeTab);
  }

  addUser(): void {
    this.router.navigate(['/admin/users/new']);
  }

  addClient(): void {
    this.router.navigate(['/admin/clients/new']);
  }
}
